/**
 * Resolution Time Chart Component
 * Distribution chart for resolution times
 */

import React from 'react';

export default function ResolutionTimeChart({ resolutionTime }) {
  if (!resolutionTime) {
    return (
      <div className="text-center py-12 text-gray-500">
        No resolution time data available
      </div>
    );
  }

  const buckets = [
    { label: '< 1 hour', value: parseInt(resolutionTime.under_1_hour || 0), color: 'bg-green-500' },
    { label: '1-4 hours', value: parseInt(resolutionTime.one_to_four_hours || 0), color: 'bg-blue-500' },
    { label: '4-24 hours', value: parseInt(resolutionTime.four_to_24_hours || 0), color: 'bg-yellow-500' },
    { label: '1-3 days', value: parseInt(resolutionTime.one_to_three_days || 0), color: 'bg-orange-500' },
    { label: '> 3 days', value: parseInt(resolutionTime.over_three_days || 0), color: 'bg-red-500' },
  ];

  const maxValue = Math.max(...buckets.map((b) => b.value));
  const total = buckets.reduce((sum, b) => sum + b.value, 0);

  return (
    <div className="space-y-4">
      {buckets.map((bucket, index) => {
        const pct = maxValue > 0 ? (bucket.value / maxValue) * 100 : 0;
        const percentOfTotal = total > 0 ? ((bucket.value / total) * 100).toFixed(1) : 0;

        return (
          <div key={index} className="space-y-1">
            <div className="flex items-center justify-between text-xs">
              <span className="font-medium text-gray-700">{bucket.label}</span>
              <span className="text-gray-600">
                {bucket.value} tickets ({percentOfTotal}%)
              </span>
            </div>
            <div className="h-6 bg-gray-100 rounded overflow-hidden">
              <div className={`h-full ${bucket.color}`} style={{ width: `${pct}%` }}></div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
